/**
 * Created by siroramirez on 09/02/17.
 */
import { Injectable }                               from '@angular/core';
import { Http, Response, Headers, RequestOptions }  from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { User } from "../../routes/users/user";
import { ApiService } from "../network/api.service";
import { Router } from "@angular/router";
import { HttpService } from '../network/http.service';

import { StorageService } from '../../core/storage/storage.service';


export enum Roles {
  UBERADMIN = 0,
  ADMIN = 1,
  WORK_MANAGER = 2
}

export enum LoginStatus {
    NOK = 0,
    OK = 1,
    OK_PENDING_ORG = 2
}

@Injectable()
export class AuthService {

    private me;

    constructor (private router: Router,
                    private http: HttpService,
                    private apiService: ApiService,
                    public storageService: StorageService) {
    }

    private getLoginUrl = (): string => this.apiService.getBaseUrl() + '/users/login_admin';

    private getForgotPasswordUrl = (): string => this.apiService.getBaseUrl() + '/users/forgot_password';

    private getResetPasswordUrl = (): string => this.apiService.getBaseUrl() + '/users/reset_password';


    login (email, password, orgId=null): Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        let data = {"username": email, "password": password};

        if (orgId) {
            data["orgId"] = orgId;
        }

        return this.http.post(this.getLoginUrl(), data, options)
            .map(res => this.extractLoginData(res))
            .catch(this.handleError)
    }

    forgotPassword (id): Observable<any> {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      let data = {"id_number": id};
      return this.http.post(this.getForgotPasswordUrl(), data, options)
        .map(res => res.text())
        .catch(this.handleError)
    }

    resetPassword (id, code, password): Observable<any> {
      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });
      let data = {"id_number": id, "code": code, "password": password};
      return this.http.post(this.getResetPasswordUrl(), data, options)
        .map(res => res.text())
        .catch(this.handleError)
    }

    setUser(user) {
        if (!user) {
            return;
        }

        let selectedOrg = this.getSelectedOrg();

        user.organizations = user.organizations.filter(item => !item._organization && item.role == Roles.UBERADMIN || item._organization && item._organization._id == selectedOrg);
        
        return this.storageService.setItem('user', JSON.stringify(user));
    }

    getUser(): Observable<User> {
        if (this.me) {
            return Observable.of(this.me);
        } else {
            let userString = this.storageService.getItem('user');

            if (!userString) {
                return Observable.throw(401);
            }

            let user = JSON.parse(userString);

            if (!user) {
                return Observable.throw(401);
            }

            return Observable.of(user);
        }
    }

    logout () {
        this.me = null;
        this.storageService.clear();
        this.router.navigate(['/login']);
    }

    isAuthenticated() {
        return this.storageService.getItem('token') ? true : false;
    }

    isWorkManager(): Observable<boolean> {
        return this.getUser()
                .map(user => user.organizations[0].role == Roles.WORK_MANAGER);
    }

    getAuthToken() {
      return this.storageService.getItem('token');
    }

    setSelectedOrg (orgId) {
      this.storageService.setItem('organization', orgId);
    }

    getSelectedOrg () {
      return this.storageService.getItem('organization');
    }

    private extractLoginData(res: Response) {
        let body = res.json();

        if ( ( !body.me || Array.isArray(!body.me.organizations) ) && ( !body.token || !body.refresh_token ) ) {
            throw 401;
        }

        if (body.token && body.refresh_token) {
            this.storageService.setItem('token', body.token);
            this.storageService.setItem('refreshToken', body.refresh_token);

            body.result = LoginStatus.OK;
        } else {
            body.result = LoginStatus.OK_PENDING_ORG;
        }

        return body;
    }

    private handleError (error: Response | any) {

        const errorMsg = error.json() || '';

        return Observable.throw(errorMsg.message);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/authentication/auth.service.ts